module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step3.6d682a65.png";